module.exports = __webpack_public_path__ + "img/kavan.1b3f635e.jpg";